import { Button, Link } from '@nerdwallet/currency';
import OpenInNewIcon from '@nerdwallet/react-icon/material/OpenInNew';
import { Fragment } from 'react';
import styles from './dynamic-button.module.scss';

import {
  DynamicTextComponent,
  DynamicTextComponentProps,
} from '../dynamic-text/dynamic-text-component';

type Cta = {
  link: string;
  text: string;
  showIcon: boolean;
  type: string;
  subtext?: string;
  phoneNumber?: string;
};

type DynamicApplyNowButtonProps = {
  cta: Cta;
  onClick?: () => void;
  ctaSubtext?: DynamicTextComponentProps;
  ctaExtraText?: DynamicTextComponentProps;
};

const getCtaSubtextTextComponent = (
  ctaSubtext?: DynamicTextComponentProps,
  cta?: Cta
) => {
  if (ctaSubtext?.text) {
    return <DynamicTextComponent {...ctaSubtext} />;
  }
  if (cta?.subtext) {
    const formattedCtaSubtext = cta?.subtext?.replace(/,/g, ',\n');
    return (
      <span
        className={styles.applyNowButtonSubText}
        style={{ textAlign: 'center', whiteSpace: 'pre-line' }}
      >
        {!cta.phoneNumber ? (
          formattedCtaSubtext
        ) : (
          <Fragment>
            {formattedCtaSubtext}{' '}
            <Link
              href={`tel:${cta.phoneNumber}`}
              target="_self"
              rel="noreferrer"
            >
              {cta.phoneNumber}
            </Link>
          </Fragment>
        )}
      </span>
    );
  }
  return null;
};

export const DynamicApplyNowButton = ({
  cta,
  onClick,
  ctaSubtext,
  ctaExtraText,
}: DynamicApplyNowButtonProps) => {
  // when text is empty it will display "Text" string as default, to prevent that
  // we apply the logic below
  const ctaExtraTextValue = ctaExtraText?.text || '';
  return (
    <div className={styles.applyNowButtonContainer}>
      <Button
        primary
        onClick={onClick}
        className={styles.applyNowButton}
        href={cta?.link}
        target="_blank"
      >
        {cta?.text}
        {cta?.showIcon && <OpenInNewIcon />}
      </Button>
      {getCtaSubtextTextComponent(ctaSubtext, cta)}
      {ctaExtraTextValue && (
        <DynamicTextComponent {...ctaExtraText} text={ctaExtraTextValue} />
      )}
    </div>
  );
};
